// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/'
import store from './store/'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI);

Vue.prototype.api = api;
Vue.prototype.imgUrl = imgUrl;
Vue.prototype.uploadUrl = uploadUrl;
Vue.prototype.showLoading = function (msg) {
  this.loading = this.$loading({
    lock: true,
    text: msg == '' ? 'Loading' : msg,
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
}
Vue.prototype.alert = function (obj) {
  alert(obj)
}
Vue.prototype.eval = function (obj) {
  return eval(obj)
}
Vue.prototype.getDate = function (time) {
  var date = new Date(time);
  if (new Date().getFullYear() == date.getFullYear()) {
    return patchZero((date.getMonth() + 1)) + '-' + patchZero(date.getDate());
  } else {
    return date.getFullYear() + '-' + patchZero((date.getMonth() + 1)) + '-' + patchZero(date.getDate());
  }
}
Vue.prototype.getFullDate = function (time) {
  var date = new Date(time);
  return date.getFullYear() + '-' + patchZero((date.getMonth() + 1)) + '-' + patchZero(date.getDate()) + ' ' + patchZero(date.getHours()) + ':' + patchZero(date.getMinutes()) + ':' + patchZero(date.getSeconds());
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js